module.exports = __webpack_public_path__ + "assets/img/37_381.46fbe2d0.jpg";